<template>
  <div class="examination-list-table-row-file">
    <div class="cell date">
      <span>{{ toJpDateFormat(pdfFile.date) }}</span>
    </div>
    <div class="cell examination-name">
      <span>{{ pdfFile.examinationName }}</span>
    </div>
    <div class="cell blood-flg">
      <span>{{ toCircleOrCross(pdfFile.bloodFlg) }}</span>
    </div>
    <div class="cell file-name">
      <span>{{ pdfFile.name }}</span>
    </div>
    <div class="cell buttons">
      <base-button-trash
        v-if="!lookOnlyFlg"
        :styles="{ width: '60px' }"
        @click="emitClick('click-delete')"
      />
      <base-button-small-white
        v-if="!lookOnlyFlg"
        :styles="{ width: '60px' }"
        @click="emitClick('click-edit')"
        >編集</base-button-small-white
      >
      <base-button-border-orange
        :styles="{ width: '80px' }"
        @click="emitClick('click-pdf')"
        >PDF表示</base-button-border-orange
      >
    </div>
  </div>
</template>

<script>
import BaseButtonBorderOrange from '@/components/parts/atoms/BaseButtonBorderOrange'
import BaseButtonSmallWhite from '@/components/parts/atoms/BaseButtonSmallWhite'
import BaseButtonTrash from '@/components/parts/atoms/BaseButtonTrash'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { toCircleOrCross } from '@/utils/convert_string'

export default {
  name: 'ExaminationListTableRowFile',

  components: {
    BaseButtonBorderOrange,
    BaseButtonSmallWhite,
    BaseButtonTrash
  },

  props: {
    pdfFile: { type: Object, default: () => ({}) }
  },

  computed: {
    ...mapGetters({
      lookOnlyFlg: 'auth/lookOnlyFlg'
    })
  },

  methods: {
    emitClick(eventName) {
      this.$emit(eventName)
    },
    toCircleOrCross(numericBoolean) {
      return toCircleOrCross(numericBoolean)
    },
    toJpDateFormat(date) {
      return moment(date, 'YYYYMMDD').format('Y年M月D日（dd）')
    }
  }
}
</script>

<style lang="scss" scoped>
$border-color: #{$light-grey};
.examination-list-table-row-file {
  box-sizing: border-box;
  width: 100%;
  min-height: 55px;
  display: flex;
  align-items: center;
  > .cell {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 5px 8px;
    word-break: break-all;
    font-feature-settings: 'palt';
    & ~ .cell {
      border-left: 1px solid transparent;
    }
    &.date {
      max-width: 220px;
      min-width: 220px;
    }
    &.examination-name {
      flex: 2;
    }
    &.blood-flg {
      max-width: 120px;
      min-width: 120px;
    }
    &.file-name {
      flex: 3;
      font-size: 13px;
    }
    &.buttons {
      max-width: 250px;
      min-width: 250px;
      justify-content: flex-end;
      column-gap: 5px;
      padding-right: 20px;
    }
  }
}
</style>
